import * as React from 'react';
import * as I18n from 'i18n-js';
import SanitizedRender from '@reverbdotcom/commons/dist/components/sanitized_render';
import URLHelpers from '../../shared/url_helpers';
import { formatInternationalizedSeconds } from '../../../lib/date_utils';

interface IProps {
  pageTitle: string;
  orderId: string;
  buyerName: string;
  orderCreatedAtSeconds: number;
}

class ShipOrderHeader extends React.Component<IProps, null> {
  renderOrderNumber() {
    return (
      <a href={URLHelpers.orderPath({ orderId: this.props.orderId })}>
        {I18n.t(
          'discovery.dashboard.selling.shipOrderViews.header.orderNumber',
          { orderId: this.props.orderId },
        )}
      </a>
    );
  }

  renderOrderDate() {
    return (
      <span className="mlr-1 mobile-d-block mobile-margin-0">
        {I18n.t(
          'discovery.dashboard.selling.shipOrderViews.header.orderedDate',
          { date: formatInternationalizedSeconds(this.props.orderCreatedAtSeconds) },
        )}
      </span>
    );
  }

  renderBuyerName() {
    return (
      I18n.t(
        'discovery.dashboard.selling.shipOrderViews.header.buyerName',
        { name: this.props.buyerName },
      )
    );
  }

  renderShippingTips() {
    return (
      <SanitizedRender
        html={
          I18n.t(
            'discovery.dashboard.selling.shipOrderViews.header.visitShippingGuide',
            { linkOpen: `<a href=${URLHelpers.shippingGuidePath}>`, linkClose: '</a>' },
          )
        }
      />
    );
  }

  render() {
    return (
      <div>
        <h1 className="size-160 weight-bold">
          {this.props.pageTitle}
        </h1>
        <div className="width-100 d-flex fx-justify-between mobile-size-90 mobile-d-block">
          <div>
            {this.renderOrderNumber()}
            {this.renderOrderDate()}
            {this.renderBuyerName()}
          </div>
          {this.renderShippingTips()}
        </div>
      </div>
    );
  }
}

export default ShipOrderHeader;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/shipping_labels/ship_order_header.tsx